import React, { useState } from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";
import homeImg from "../assets/home.png";
import aboutusImg from "../assets/about-us.png";
import csrImg from "../assets/our-csr-programs.png";
import contactImg from "../assets/contact.png";
import DonatePage from "../components/DonatePage";
import { NavLink, useLocation } from "react-router-dom";



function Navbar() {

  const handleClick = () => {
    console.log("Home clicked");
  };
  
  const [showModal, setShowModal] = useState(false)
  const location = useLocation();

  return (
    <div className="navbar">

      {/* LEFT LOGO */}
      <div className="logo">
        <img src={logo} alt="Dhara Logo" />
      </div>

      {/* CENTER MENU */}
      <div className="menu">
          {/* HOME */}
        <NavLink to="/" className="nav-item">
        {location.pathname === "/" ? (
         
            <img src={homeImg} alt="home" className="nav-img"/>
            
        ) : (
          "Home"
        )}
      </NavLink>

         {/* ABOUT */}
          <NavLink to="/aboutus" className="nav-item">
          
        {location.pathname === "/aboutus" ? (
         
            <img src={aboutusImg} alt="aboutus" className="nav-img"/>
            
        ) : (
          "About us"
        )}
      </NavLink>
    
         {/* CSR */}
        <NavLink to="/our-csr" className="nav-item">
        {location.pathname === "/our-csr" ? (
             <img src={csrImg} alt="csr" className="nav-img"/>
        ) : (
          "Our CSR Programs"
        )}
      </NavLink>

        {/* CONTACT */}
         <NavLink to="/contact" className="nav-item">
        {location.pathname === "/contact" ? (
             <img src={contactImg} alt="contact" className="nav-img"/>
        ) : (
          "Contact"
        )}
      </NavLink>
      </div>

      {/* RIGHT BUTTON */}
      {/* <div className="right">
        <button className="donate-btn" onClick={()=>setShowModal(true)}
          >Donate</button>
          {showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      
      <button
        className="close-btn"
        onClick={() => setShowModal(false)}
      >
        ✖
      </button>

      <DonatePage />
    </div>
  </div>
)}
    </div> */}
    </div>
  );
}

export default Navbar;